import { Beforeunload as ReactBeforeunload  } from 'react-beforeunload';

export const BeforeUnload = (props) => {
  if (window.LFApp?.improveDeveloperExperience) return null; // it's frustration to always confirm reload on localhost
  
  return (
    <ReactBeforeunload {...props} />
  )
}